import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const StyledHeading = styled.h1`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleHeading
      : textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
`;

export const FormInputWrapper = styled.div`
  padding-top: 28px;
`;

export const CharacterLimitHint = styled.p<{ $atLimit?: boolean }>`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodySmall
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${(props) =>
    props.$atLimit
      ? props.theme.isVaultVariant
        ? props.theme.newPalette.red.R300
        : props.theme.atlas.semantic.color.status.error.default
      : props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N600
        : props.theme.atlas.semantic.color.type.muted};
  margin: 8px 0 0 0;
`;
